import { Flex, Box, Button, DropdownMenu } from '@workwhile/ui'
import { Ellipsis, Plus } from 'lucide-react'
import React from 'react'
import { useCompanyGroupsContextValue } from '../context/CompanyGroupsProvider'
import { QueryStatus } from 'components/QueryStatus'
import { Header } from 'components/Header'
import { CompanyGroupsTable } from './CompanyGroupsTable'
import { Search } from './Search'
import { useCompanyGroupsWorkflowsContextValue } from '../context/CompanyGroupsWorkflowsProvider'

const CompanyGroupsHeader = () => {
  const { state, actions } = useCompanyGroupsContextValue()
  const { createCompanyGroupFlow } = useCompanyGroupsWorkflowsContextValue()

  return (
    <Header
      title="Company Groups"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
          <DropdownMenu
            trigger={
              <Button variant="secondary" style={{ padding: 4 }} kind="medium">
                <Ellipsis />
              </Button>
            }
          >
            <DropdownMenu.Item onClick={createCompanyGroupFlow.open} asChild>
              <Flex as="span" alignItems="center" style={{ gap: 8 }}>
                <Plus size={14} />
                Create Group
              </Flex>
            </DropdownMenu.Item>
          </DropdownMenu>
        </Flex>
      }
    />
  )
}

export const CompanyGroupsMain = () => {
  return (
    <>
      <CompanyGroupsHeader />
      <Box margin={3}>
        <Search />
        <CompanyGroupsTable />
      </Box>
    </>
  )
}
